// react component CreateActionTracking
import React, { useEffect, useState, useCallback } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Container,
  DialogContentText,
  FormControl,
  Grid,
  Modal,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import boxStyles from '../../../styles/boxStyles';
import LoadingSpinner from '../../../components/LoadingSpinner';
import ApiService from '../../../services/ApiService';
import DetailInput from './DetailInput';
import ActionDetailTable from './ActionDetailTable';
import { Add } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ActionHeader from './ActionHeader';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const CreateActionTracking = ({
  actionTrackingDetail = null,
  onDetailUpdatedFromCreator = () => {},
}) => {
  const history = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [kegiatanActionTracking, setKegiatanActionTracking] = useState([]);
  const [open, setOpen] = useState(false);
  const [autoFormFill, setAutoFormFill] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [actionHeader, setActionHeader] = useState(null);
  const [actionTrackinDetails, setActionTrackinDetails] = useState([]);
  const [editableDetail, setEditableDetail] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errors, setErrors] = useState([]);
  const [difficultyPriorityData, setDifficultyPriorityData] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [actionTracking, setActionTracking] = useState({
    createdBy: '',
    idLapInvestigasi: 0,
    saveAs: '',
    tglDisahkan: '',
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') {
      e.stopPropagation();
      return;
    }
    setOpen(false);
    setOpenDeleteDialog(false);
  };

  const getKegiatanActionTracking = () => {
    setIsLoading(true);
    ApiService.getKegiatanActionTracking()
      .then(({ data }) => {
        setKegiatanActionTracking([...data.payload]);
      })
      .finally(() => setIsLoading(false));
  };

  const handleAutoFillRekomendasi = (data, message = null) => {
    if (message) {
      setErrors(message);
      setSnackbarOpen(true);
      return;
    }
    setActionTrackinDetails(
      data.map((item) => ({
        id: item.idRekomendasi || 0,
        idRekomendasiLapInvest: 0,
        pembahasan: item.rekomenadasi || '',
        tindakLanjut: '-',
        picEmail: '',
        picDisplayName: '',
        picJabatan: '',
        reviewerEmail: '',
        reviewerDisplayName: '',
        reviewerJabatan: '',
        priority: 3,
        idUpload: 0,
        dueDate: moment().add(30, 'days').format('DD-MMMM-YYYY').toString(),
      }))
    );
  };

  useEffect(() => {
    getKegiatanActionTracking();

    if (actionTrackingDetail && !isLoading) {
      setActionTrackinDetails(actionTrackingDetail.details);

      setActionHeader({
        idLapInvestigasi: actionTrackingDetail.id,
        tglDisahkan: actionTrackingDetail.tglDisahkan,
        judul: actionTrackingDetail.nomorLapInvest,
        idRegion: actionTrackingDetail.idRegion,
        namaRegion: actionTracking.namaRegion,
        idLokasi: actionTrackingDetail.idLokasi,
        namaLokasi: actionTrackingDetail.namaLokasi,
        approverEmail: actionTrackingDetail.approverEmail,
        approverDisplayName: actionTrackingDetail.approverDisplayName,
        approverJabatan: actionTrackingDetail.approverJabatan,
        idUpload: 0,
        ...actionTrackingDetail,
      });
      setActionTracking({ ...actionTrackingDetail });

      const isAutoFill = kegiatanActionTracking.find(
        (item) => item.id === actionTrackingDetail.idKegiatan
      )?.isAuto;

      setAutoFormFill(isAutoFill);
    }
  }, []);

  useEffect(() => {
    if (actionHeader && actionHeader.tglDisahkan) {
      ApiService.getMatrixDueDate({
        tanggalDisahkan: moment.utc(actionHeader.tglDisahkan).toDate(),
      }).then(({ data }) => {
        setDifficultyPriorityData(data.payload);
      });
    } else {
      ApiService.getMatrixDueDate({
        tanggalDisahkan: moment().utc().toDate(),
      }).then(({ data }) => {
        setDifficultyPriorityData(data.payload);
      });
    }
  }, [actionHeader]);

  const handleKegiatan = (event, value) => {
    if (!value) return;

    const { isAuto, ...kegiatan } = value;
    setActionTracking({ ...actionTracking, idKegiatan: kegiatan.id });
    setAutoFormFill(isAuto);
  };

  const Kegiatan = (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h6" marginTop={3}>
          Kegiatan
        </Typography>
      </Grid>
      <Grid item xs={12} marginTop={4}>
        <FormControl fullWidth>
          <Autocomplete
            name="kegiatan"
            onChange={handleKegiatan}
            required
            getOptionLabel={(option) => option.name}
            options={kegiatanActionTracking}
            renderInput={(params) => <TextField {...params} label="Kegiatan" />}
            value={kegiatanActionTracking.find(
              (item) => item.id === actionTracking?.idKegiatan
            )}
            disabled={actionTracking.id}
          />
        </FormControl>
      </Grid>
    </Grid>
  );

  const tableHeaders = [
    { label: 'No', field: 'no' },
    {
      label: 'Pembahasan',
      field: 'pembahasan',
      tooltip: true,
    },
    { label: 'Tindak Lanjut', field: 'tindakLanjut', tooltip: true },

    { label: 'PIC', field: 'picDisplayName', tooltip: true },
    { label: 'Reviewer', field: 'reviewerDisplayName', tooltip: true },
    {
      label: 'Priority',
      field: 'priority',
      formatter: (val) => {
        let backgroundColor = '#BE0000'; // Default color

        if (val === 1) {
          backgroundColor = '#369120';
        } else if (val === 2) {
          backgroundColor = '#FFFF00';
        } else if (val === 3) {
          backgroundColor = '#BE0000';
        }

        const difficulties = [
          { value: 1, label: 'Low' },
          { value: 2, label: 'Medium' },
          { value: 3, label: 'High' },
        ];

        return (
          <div
            style={{
              backgroundColor,
              width: '100px',
              height: '40px',
              borderRadius: '5px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {difficulties.find((item) => item.value === val)?.label || 'High'}
          </div>
        );
      },
      tooltip: false,
    },
    {
      label: 'Status',
      field: 'statusDetailName',
      formatter: (val) => {
        let backgroundColor = '#ffd500'; // Default color

        if (val === 'Open') {
          backgroundColor = '#ffd500';
        } else if (val === 'Accepted' || val === 'Extend') {
          backgroundColor = '#ff5e00';
        } else if (val === 'Decline' || val === 'Return to PIC') {
          backgroundColor = '#fff700';
        } else if (val === 'Review') {
          backgroundColor = '#0ff7f3';
        } else if (val === 'Closed') {
          backgroundColor = '#05f535';
        }

        return (
          <div
            style={{
              backgroundColor,
              width: '100px',
              height: '40px',
              borderRadius: '5px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {val || 'Open'}
          </div>
        );
      },
      tooltip: false,
    },
    {
      label: 'Due Date',
      field: 'dueDateCreator',
      formatter: (val, row) => {
        return val
          ? moment.utc(val).format('DD MMMM YYYY')
          : moment.utc(row?.dueDate).format('DD MMMM YYYY');
      },
    },
    {
      label: 'Due Date Extend',
      field: 'dueDateExtend',
      formatter: (val, row) => {
        return val ? moment.utc(val).format('DD MMMM YYYY') : '-';
      },
    },
    {
      label: 'Remark',
      field: 'statusRemark',
      tooltip: true,
    },
    {
      label: 'Attachment',
      field: 'fileUploadOriginalName',
      formatter: (val, row) => {
        return row.fileUploadUrl ? (
          <a
            href={row.fileUploadUrl}
            target="_blank"
            rel="noreferrer"
            onClick={async (e) =>
              await ApiService.viewFile(row.fileUploadUrl, e)
            }
          >
            {val}
          </a>
        ) : (
          '-'
        );
      },
      tooltip: true,
    },
    { label: 'Actions', field: 'actions' },
  ];

  const handleAddedDetail = (detail) => {
    const { priority, tingkatKesulitan } = detail;
    const tglDisahkan = actionHeader?.tglDisahkan;
    let errorMessages = [];

    if (actionTrackingDetail) {
      if (!detail.dueDate) {
        errorMessages.push('Due Date is required.');
      }
    } else if (!detail.dueDate) {
      errorMessages.push('Due Date is required.');
    }

    if (!priority) {
      errorMessages.push('Priority is required.');
    }

    if (!tingkatKesulitan) {
      errorMessages.push('Tingkat Kesulitan is required.');
    }

    if (!tglDisahkan) {
      errorMessages.push('Tanggal Disahkan is required.');
    }

    if (errorMessages.length > 0) {
      setErrors(errorMessages);
      setSnackbarOpen(true);
      return;
    }

    ApiService.checkDueDate({
      tanggalDisahkan: moment.utc(actionHeader.tglDisahkan).toDate(),
      dueDate: moment.utc(detail.dueDate).toDate(),
      priotiry: detail.priority,
      tingkatKesulitan: detail.tingkatKesulitan,
    })
      .then(({ data }) => {
        if (!data.isOk) {
          throw new Error(data.message);
        }
        setActionTrackinDetails([...actionTrackinDetails, detail]);
        setOpen(false);
      })
      .catch((e) => {
        setErrors(e.message);
        setSnackbarOpen(true);
      });
  };

  const handleUpdatedDetail = (detail) => {
    const { priority, tingkatKesulitan } = detail;
    const tglDisahkan = actionHeader?.tglDisahkan;
    let errorMessages = [];

    if (actionTrackingDetail) {
      if (!detail.id && !detail.dueDate) {
        errorMessages.push('Due Date is required.');
      }
    }

    if (!priority) {
      errorMessages.push('Priority is required.');
    }

    if (!tingkatKesulitan) {
      errorMessages.push('Tingkat Kesulitan is required.');
    }

    if (!tglDisahkan) {
      errorMessages.push('Tanggal Disahkan is required.');
    }

    if (errorMessages.length > 0) {
      setErrors(errorMessages);
      setSnackbarOpen(true);
      return;
    }

    ApiService.checkDueDate({
      tanggalDisahkan: moment.utc(actionHeader.tglDisahkan).toDate(),
      dueDate: moment.utc(detail.dueDate).toDate(),
      priotiry: detail.priority,
      tingkatKesulitan: detail.tingkatKesulitan,
    })
      .then(({ data }) => {
        if (!data.isOk) {
          throw new Error(data.message);
        }
      })
      .then(() => {
        const updatedDetail = {
          idDetail: detail.id || null,
          tindakLanjut: detail.tindakLanjut || null,
          pembahasan: detail.pembahasan || null,
          status: detail.statusDetailName || null,
          noteStatus: detail.statusRemark || null,
          uploadFileId: detail.uploadFileId || null,
          isUpdateFromCreator: !!detail.id,
          picEmail: detail.picEmail || '',
          picDisplayName: detail.picDisplayName || '',
          picJabatan: detail.picJabatan || '',
          reviewerEmail: detail.reviewerEmail || '',
          reviewerDisplayName: detail.reviewerDisplayName || '',
          reviewerJabatan: detail.reviewerJabatan || '',
          fungsiId: detail.fungsiId || null,
          dueDate: detail.dueDate ? moment.utc(detail.dueDate).toDate() : null,
          priority: detail.priority || null,
          tingkatKesulitan: detail.tingkatKesulitan || null,
          dueDateExtend: detail.dueDateExtend
            ? moment.utc(detail.dueDateExtend).toDate()
            : null,
        };
        if (updatedDetail.idDetail) {
          ApiService.updateDetailActionTracking(updatedDetail)
            .then((resp) => {
              if (!resp.data.isOk && resp.data.payload) {
                setErrors(resp.data.payload);
                setSnackbarOpen(true);
                return false;
              }

              const newActionTrackingDetails = [...actionTrackinDetails];
              const index = newActionTrackingDetails.findIndex(
                (detail) => detail.id === updatedDetail.idDetail
              );
              if (index !== -1) {
                newActionTrackingDetails[index] = updatedDetail;
                newActionTrackingDetails[index].id = updatedDetail.idDetail;
                setActionTrackinDetails(newActionTrackingDetails);
              }
              setOpen(false);
              setEditableDetail(null);

              // get params id
              setIsLoading(true);
              const id = window.location.pathname.split('/').pop();
              ApiService.getActionTrackingById(id)
                .then(({ data }) => {
                  // new detail with null id
                  const newDetails = actionTrackinDetails.filter(
                    (item) => !item.id
                  );
                  // old detail with id
                  const oldDetails = data.payload.details;

                  // merge new detail with old detail
                  const mergedDetails = [...oldDetails, ...newDetails];

                  // update detail
                  setActionTrackinDetails(mergedDetails);
                })
                .finally(() => {
                  setIsLoading(false);
                });
            })
            .catch((e) => {
              setErrors(e.message);
              setSnackbarOpen(true);
              return false;
            });
        }
      })
      .catch((e) => {
        setErrors(e.message);
        setSnackbarOpen(true);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const deleteDetail = (index) => {
    return () => {
      const newActionTrackingDetails = [...actionTrackinDetails];
      newActionTrackingDetails.splice(index, 1);
      setActionTrackinDetails(newActionTrackingDetails);
    };
  };

  const editDetail = (index) => {
    ApiService.getFungsiActionTracking().then(({ data }) => {
      setEditableDetail({
        ...actionTrackinDetails[index],
        fungsiName: data.payload.find(
          (item) => item.id === actionTrackinDetails[index].fungsiId
        )?.name,
      });

      handleOpen();
    });
  };

  const handleSnackbarClose = () => {
    setSnackbarMessage(null);
    setSnackbarOpen(false);
  };

  const renderActionColumn = (item, index) => {
    // Customize the content of the action column based on the item and index
    return (
      item.statusDetailName !== 'Closed' && (
        <div style={{ textAlign: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => editDetail(index)}
          >
            <EditIcon />
          </Button>
          {(item.statusDetailName === 'Draft' || item.status === '') && (
            <Button
              variant="outlined"
              color="primary"
              onClick={deleteDetail(index)}
            >
              <DeleteIcon />
            </Button>
          )}
        </div>
      )
    );
  };

  const createActionTracking = (isDraft) => {
    if (!actionHeader) {
      setErrors('Action header is missing.');
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      ...actionTracking,
      ...actionHeader,
      tglDisahkan: moment.utc(actionHeader.tglDisahkan).toDate(),
      details: [
        ...actionTrackinDetails.map((item) => ({
          ...item,
          dueDate: item.dueDate
            ? moment.utc(item.dueDate).toDate()
            : moment().add(30, 'days').toISOString(),
        })),
      ],
      saveAs: isDraft ? 'draft' : 'submit',
    };

    setIsSubmitting(true);

    ApiService.createActionTracking({
      ...actionTracking,
      ...actionHeader,
      tglDisahkan: moment.utc(actionHeader.tglDisahkan).toDate(),
      details: [
        ...actionTrackinDetails.map((item) => ({
          ...item,
          dueDate: item.dueDate
            ? moment.utc(item.dueDate).toDate()
            : moment().add(30, 'days').toISOString(),
        })),
      ],
      saveAs: isDraft ? 'draft' : 'submit',
    })
      .then(({ data }) => {
        if (!data.isOk) {
          setIsSubmitting(false);
          setErrors(data.payload);
          setSnackbarOpen(true);
          return;
        }
        setIsSubmitting(false);
        setSnackbarMessage(
          `Action Tracking ${data.payload.noActionTracking} created successfully`
        );
        setSnackbarOpen(true);
        history('/hsse/action-tracking');
      })
      .catch((e) => {
        setIsSubmitting(false);
        setErrors(e.message);
        setSnackbarOpen(true);
      });
  };

  const updateActionTracking = (isDraft) => {
    if (!actionHeader) {
      setErrors('Action header is missing.');
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      ...actionTracking,
      ...actionHeader,
      tglDisahkan: moment.utc(actionHeader.tglDisahkan).toDate(),
      details: [
        ...actionTrackinDetails.map((item) => ({
          ...item,
          dueDate: item.dueDate
            ? moment.utc(item.dueDate).toDate()
            : moment().add(30, 'days').toISOString(),
        })),
      ],
      saveAs: isDraft ? 'draft' : 'submit',
    };

    setIsSubmitting(true);

    ApiService.updateActionTracking(payload)
      .then(({ data }) => {
        if (!data.isOk) {
          setIsSubmitting(false);
          setErrors(data.payload);
          setSnackbarOpen(true);
          return;
        }
        setIsSubmitting(false);
        setSnackbarMessage(
          `Action Tracking ${data.payload.noActionTracking} updated successfully`
        );
        setSnackbarOpen(true);
        history('/hsse/action-tracking');
      })
      .catch((e) => {
        setIsSubmitting(false);
        setErrors(e.message);
        setSnackbarOpen(true);
      });
  };

  const deleteActionTracking = () => {
    const payload = {
      id: actionTrackingDetail.id,
    };

    setIsSubmitting(true);

    ApiService.deleteDraft(payload)
      .then(({ data }) => {
        if (!data.isOk) {
          setErrors(data.payload);
          throw new Error(data.message);
        }
        setIsSubmitting(false);
        setSnackbarMessage(
          `Action Tracking ${data.payload.noActionTracking} deleted successfully`
        );
        setSnackbarOpen(true);
        history('/hsse/action-tracking');
      })
      .catch((e) => {
        setIsSubmitting(false);
        setErrors(e.message);
        setSnackbarOpen(true);
      });
  };

  const handleSearchActionTrackinDetails = useCallback(
    (e) => {
      const { value } = e.target;
      if (!value) {
        setActionTrackinDetails(actionTrackingDetail.details);
        return;
      }
      const filteredData = actionTrackingDetail.details.filter(
        (item) =>
          // pic name, reviewer name, fungsi name, tingkat kesulitan, priority, status, due date
          item.pembahasan.toLowerCase().includes(value.toLowerCase()) ||
          item.tindakLanjut.toLowerCase().includes(value.toLowerCase()) ||
          item.picDisplayName.toLowerCase().includes(value.toLowerCase()) ||
          item.reviewerDisplayName
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          item.tingkatKesulitan.toString().includes(value.toLowerCase()) ||
          item.priority.toString().includes(value.toLowerCase()) ||
          item.statusDetailName.toLowerCase().includes(value.toLowerCase()) ||
          (item.dueDateCreator &&
            moment.utc(item.dueDateCreator)
              .format('DD MMMM YYYY')
              .toLowerCase()
              .includes(value.toLowerCase()))
      );
      setActionTrackinDetails(filteredData);
    },
    [actionTrackingDetail]
  );

  const Detail = (
    <Grid container>
      <Grid item xs={12}>
        <Grid container alignItems="center">
          <Grid item xs={12} alignItems="center">
            <Typography variant="h6" marginTop={3}>
              Detail Pembahasan
            </Typography>
          </Grid>
          <Grid item xs={8} alignItems="center" marginTop={4}>
            {actionTracking?.statusHeaderName !== 'Closed' && (
              <Button
                variant="outlined"
                color="primary"
                startIcon={<Add />}
                onClick={() => {
                  if (!actionHeader?.tglDisahkan) {
                    setErrors([
                      'Tanggal Disahkan diperlukan sebelum menambahkan pembahasan.',
                    ]);
                    setSnackbarOpen(true);
                    return;
                  }
                  setEditableDetail(null);
                  handleOpen();
                }}
              >
                Add
              </Button>
            )}
          </Grid>
          <Grid item xs={4} marginTop={4}>
            <FormControl fullWidth>
              <TextField
                label="Search"
                variant="outlined"
                onKeyDown={handleSearchActionTrackinDetails}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} marginTop={4}>
        <Box sx={{ overflowX: 'auto', maxWidth: { lg: 1366, xl: 1920 } }}>
          <ActionDetailTable
            data={actionTrackinDetails}
            headers={tableHeaders}
            renderAction={renderActionColumn}
          />
        </Box>
      </Grid>
      {actionTrackingDetail &&
        (actionTracking?.statusHeaderName === 'Draft' ||
          actionTracking.role === 'Admin' ||
          actionTracking.role === 'Creator') &&
        actionTracking?.statusHeaderName !== 'Closed' && (
          <Grid item xs={12} marginTop={4}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => updateActionTracking(false)}
              disabled={isSubmitting}
            >
              Update & Submit
            </Button>
            {actionTracking?.statusHeaderName === 'Draft' && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => updateActionTracking(true)}
                disabled={isSubmitting}
                sx={{ marginLeft: 2 }}
              >
                Save as Draft
              </Button>
            )}
            {actionTracking?.statusHeaderName === 'Draft' && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpenDeleteDialog(true)}
                sx={{ marginLeft: 2 }}
                disabled={isSubmitting}
              >
                Delete
              </Button>
            )}
          </Grid>
        )}

      {!actionTrackingDetail &&
        actionTracking?.statusHeaderName !== 'Closed' && (
          <Grid item xs={12} marginTop={4}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => createActionTracking(false)}
              disabled={isSubmitting}
            >
              Create & Submit
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => createActionTracking(true)}
              disabled={isSubmitting}
              sx={{ marginLeft: 2 }}
            >
              Save as Draft
            </Button>
          </Grid>
        )}
    </Grid>
  );

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    margin: '2% 0',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  return (
    <Container maxWidth>
      <h1>{actionTrackingDetail ? 'Edit' : 'Create'} Action Items</h1>
      <Box component="div" sx={{ ...boxStyles }}>
        {isLoading ? <LoadingSpinner /> : Kegiatan}
      </Box>
      <Box component="div" sx={boxStyles} style={{ marginTop: '50px' }}>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <ActionHeader
            actionHeaderState={[actionHeader, setActionHeader]}
            isAuto={autoFormFill}
            onAutoFillRekomendasi={handleAutoFillRekomendasi}
            onHeaderSet={() => {}}
            action={'create'}
          />
        )}
      </Box>
      <Box
        component="div"
        sx={boxStyles}
        id="tabel2"
        style={{ marginTop: '50px', maxWidth: '100%' }}
      >
        {isLoading ? <LoadingSpinner /> : Detail}
      </Box>

      <Modal open={open} onClose={handleClose} disableBackdropClick>
        <Box
          component="div"
          sx={{ ...modalStyle, overflowY: 'auto', maxHeight: '90vh' }}
        >
          <DetailInput
            setOpen={setOpen}
            onDetailAdded={handleAddedDetail}
            onDetailUpdated={handleUpdatedDetail}
            detail={editableDetail}
            actionHeader={actionHeader}
            difficultyPriorityData={difficultyPriorityData}
          />
        </Box>
      </Modal>

      {snackbarOpen && !snackbarMessage && (
        <Modal open={snackbarOpen} onClose={() => setSnackbarOpen(false)}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <h2>Notifikasi</h2>
            <ul>
              {Array.isArray(errors) ? (
                errors.map((error, index) => <li key={index}>{error}</li>)
              ) : (
                <li>{errors}</li>
              )}{' '}
            </ul>
            <Button
              sx={{ marginLeft: 'auto' }}
              variant="contained"
              onClick={() => setSnackbarOpen(false)}
            >
              Tutup
            </Button>
          </Box>
        </Modal>
      )}

      {snackbarMessage && snackbarOpen && (
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          message={snackbarMessage}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        />
      )}

      <Dialog
        open={openDeleteDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
      >
        <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure want to delete this Action Tracking?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button
            onClick={() => deleteActionTracking()}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CreateActionTracking;
